<template>
  <div class="signcontract">
    <el-upload :disabled="filelist.length >= 5 || !isUpload()" action="" :headers="headers" :limit="5"
      :on-exceed="handleExceed" :auto-upload="true" style="display: flex" data="" :http-request="onUpload"
      :file-list="filelist" :on-change="handleChanged">
      <template #trigger>
        <div style="padding: 0 75px">
          <div>
            <img src="@/assets/img/select_file.png" alt="Select File" />
          </div>
          <div style="margin-top: -20px">
            <base-button style="margin-left: 10px; width: 170px" :disabled="filelist.length >= 5 || !isUpload()"
              round>Select file</base-button>
          </div>
        </div>
      </template>
      <template #file="{ file, files }">
        <div style="
            display: flex;
            margin: 0 15px;
            align-items: center;
            column-gap: 15px;
            width: 480px;
          ">
          <div style="padding-right: 27.8px; align-items: center; display: flex">
            <el-icon>
              <Paperclip />
            </el-icon>
          </div>
          <div>
            <el-icon style="font-size: 26px">
              <Document />
            </el-icon>
          </div>
          <div style="flex-grow: 1; text-align: left">
            <el-link :underline="false" @click="openFile(file)">
              {{ file.name }}</el-link>
          </div>
          <div style="width: 32%" v-if="(file.status || 'success') !== 'success' && isProgress">
            <div>
              <el-progress :percentage="progressPercent" />
            </div>
          </div>
          <div v-if="(file.status || 'success') !== 'success' && isProgress">
            <div>
              {{ fileSize(file.size) }}
            </div>
          </div>
          <div v-if="IsAllUpdateDraftContractUpload() || (isUpload() && file.delete != 'notdelete')">
            <base-button link @click="handleRemoved(file, files)">
              <el-icon>
                <Close />
              </el-icon>
            </base-button>
          </div>
        </div>
      </template>
    </el-upload>
  </div>
</template>

<script setup>
import baseButton from '@/components/newUI/BaseButton';
import { ElMessage } from 'element-plus';
import { Close, Paperclip, Document } from '@element-plus/icons-vue';
import { reactive, ref, watch } from 'vue';
import store from '@/store';
import { useContractDraftStore } from '@/store/contractDraft';
import { useContractStore } from '@/store/contract';
import contractnet from '@/network/contractnet';
import { request } from '@/network/request';
import { useAuthorityStore } from '@/store/authority';

const useAuthority = useAuthorityStore();
const props = defineProps({
  ContractDraftId: {
    type: Number,
    default: 0,
  },
  FilePath: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  UploadType: {
    type: String,
  },
  OrderStatus: {
    type: String,
    description: '订单状态',
  },
  Signed: {
    type: String,
    description: '签署状态',
  },
});
const useContractDraft = useContractDraftStore();
const useContract = useContractStore();
const headers = reactive({
  Authorization: store.state.xToken,
});
//是否可上传,删除
//const isUpload = ref(false);
const selectFileDisabled = ref(false);
//status==Issued&&signed==Open才可以上传,删除
const isUpload = () => {
  if (useContract.Unit.alias == 'BUS') {
    //是否有操作权限
    //if (!useContract.bEnableSubmit) {
    if (useContract.getContractFunctionPermission('SubmitContract')?.disable) {
      return false;
    }
    if (props.UploadType == 'ApprovalDocument') {
      if (useContract.ContractSummary.status == 'Open') {
        return true;
      } else {
        return false;
      }
    } else {
      return (
        useContract.ContractSummary.status == 'Issued' &&
        useContract.ContractSummary.signed == 'Open'
      );
    }
  } else if (useContract.Unit.alias == 'BB') {
    if (IsAllUpdateDraftContractUpload()) {
      return true;
    }
    if (GovernmentUploadPDF()) {
      return true;
    }
    if (props.UploadType == 'ApprovalDocument') {
      if (useContract.ContractSummary.status == 'Open') {
        return true;
      } else {
        return false;
      }
    }
    if (!props.UploadType || props.UploadType == 'SignedContract') {
      // Submit Job操作权限
      if (
        !useContract.getContractFunctionPermission('SubmitSignedContract')
          ?.enable
      ) {
        return false;
      }

      return props.OrderStatus !== 'Completed';
    }
  }
};
//System Admin任何時候都可以加減Approval Document/SignedContract 的PDFs, 除了status是Cancel/Void/Completed外
const IsAllUpdateDraftContractUpload = () => {
  if (props.OrderStatus !== 'Completed' && useContract.ContractSummary.status !== 'Void' && useContract.ContractSummary.status !== 'Cancel' && useAuthority.GetAuthority('SuFunction_AllUpdateDraftContractUpload')) {
    return true;
  }
};
//Signed = Signed之後 , DC 的advertiser 是Government ,用戶可以繼續上載PDF直至共5個,所有PDF上載後便不能刪除
const GovernmentUploadPDF = () => {
  if (useContract.ContractSummary.clientType === 'DC' && useContract.ContractSummary.businessNature === 'Government' && useContract.ContractSummary.signed === 'Signed' && useAuthority.GetAuthority('SubFunction_GovernmentUploadPDF')) {
    return true;
  }
};
// isUpload.value =
//   useContract.ContractSummary.status == 'Issued' &&
//   useContract.ContractSummary.signed == 'Open';

const progressPercent = ref(100);
const isProgress = ref(false);
// const selectFileDisabled = ref(props.disabled);

const handleExceed = (files) => {
  // upload.value.clearFiles();
  // const file = files[0];
  // file.uid = genFileId();
  // upload.value.handleStart(file);
};

const filelist = ref([]);

const upload = ref();

// #region Event

// 选中文件
const handleChanged = (file, files) => {
  selectFileDisabled.value = files.length >= 5;
};

// 删除文件
const handleRemoved = async (file) => {
  const signedContractFile = await contractnet
    .RemoveContractPDF(props.ContractDraftId, file.uid, props.UploadType)
    .then((res) => res.data);

  UpdateModelValue_SignedContractFile(JSON.stringify(signedContractFile));
  // upload.value.handleRemove(file);
  //是否可以上传,小于5个就可以上传
  selectFileDisabled.value = signedContractFile.length >= 5;
};

const RefreshFileList = (val) => {
  var files = JSON.parse(val || '[]');

  filelist.value = [];

  files.forEach((t) => {
    var arrs = t.split(';');
    if (arrs.length >= 4) {
      filelist.value.push({
        uid: arrs[0],
        name: arrs[2],
        url: arrs[1],
        delete: arrs[3],
      });
    }
  });

  filelist.value = filelist.value.sort((a, b) => a.uid - b.uid);
};

const onUpload = async (file) => {
  var data = new FormData();
  var UploadType = props.UploadType;
  data.append('ContractDraftId', props.ContractDraftId);
  data.append('uid', file.file.uid);
  data.append('file', file.file);
  // if (!props.UploadType || UploadType == 'SignedContract') {
  //   if (
  //     useContract.ContractSummary.status == 'Issued' &&
  //     props.Signed != 'Open'
  //   ) {
  //     UploadType = 'SupplementaryFile';
  //   }
  // }
  data.append('UploadType', UploadType);
  progressPercent.value = 0;

  const upload_res = await request({
    url: '/Contract/UploadContractPDF',
    method: 'post',
    data,
    onUploadProgress: handleProgress,
  }).then((res) => res);

  var message = upload_res.data.message || '';
  const signContractFiles = upload_res.data.data;
  if (message !== '') {
    ElMessage({
      message,
      type: 'warning',
    });

    RefreshFileList(signContractFiles);

    return;
  }

  UpdateModelValue_SignedContractFile(signContractFiles);

  isProgress.value = true;
};

const UpdateModelValue_SignedContractFile = (signedContractFile) => {
  var draft = useContractDraft.ContractDrafts.find(
    (t) => t.id === props.ContractDraftId
  );
  if (props.UploadType == 'ApprovalDocument') {
    draft.approvalDocumentFile = signedContractFile;
  } else {
    draft.signedContractFile = signedContractFile;
  }
};

// 文件上传进度
const handleProgress = (e) => {
  progressPercent.value = Number(((e.loaded / e.total) * 100).toFixed(2));

  setTimeout(() => {
    isProgress.value = false;
  }, 500);
};

const fileSize = (total) => {
  var size = parseInt(total / 1024);
  if (size < 1024) {
    return size + 'KB';
  }

  size = parseFloat(size / 1024).toFixed(2);
  return size + 'MB';
};

const openFile = (file) => {
  const contractnet = require('@/network/contractnet').default;
  contractnet
    .downloadContract(useContract.cId, undefined, file.uid, props.UploadType)
    .then((res) => {
      if ((res.data.message || '') !== '') {
        ElMessage({
          message: res.data.message,
          type: 'warning',
        });
      }

      const urlJs = require('@/assets/js/URLParams').default;
      urlJs.openFile(res);
    });
};

const bSelectFileDisabled = () => {
  return filelist.value.length >= 5;
};

watch(
  () => props.FilePath,
  (newVal) => {
    RefreshFileList(newVal || '[]');
  },
  { immediate: true }
);

// #endregion
</script>

<style>
.signcontract .el-upload-list__item .el-progress,
.signcontract .el-upload-list__item:hover .el-progress {
  position: relative !important;
  top: 0;
  width: auto;
}

.signcontract .el-upload-list__item .el-progress__text,
.signcontract .el-upload-list__item:hover .el-progress__text {
  position: relative !important;
  top: 0;
}

.signcontract .el-upload-list__item:hover.is-ready,
.signcontract .el-upload-list__item:hover.is-success {
  background: #fff !important;
}
</style>
